
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all json files for each language
import common_ja from './locales/ja/common.json';
import home_ja from './locales/ja/home.json';
import customer_ja from './locales/ja/customer.json';
import deleteCustomer_ja from './locales/ja/deleteCustomer.json';
import billing_ja from './locales/ja/billing.json';
import customerInfo_ja from './locales/ja/customerInfo.json';
import deleteScheduled_ja from './locales/ja/deleteScheduled.json';
import teamManagement_ja from './locales/ja/teamManagement.json';
import activity_ja from './locales/ja/activity.json';

import common_en from './locales/en/common.json';
import home_en from './locales/en/home.json';
import customer_en from './locales/en/customer.json';
import deleteCustomer_en from './locales/en/deleteCustomer.json';
import billing_en from './locales/en/billing.json';
import customerInfo_en from './locales/en/customerInfo.json';
import deleteScheduled_en from './locales/en/deleteScheduled.json';
import teamManagement_en from './locales/en/teamManagement.json';
import activity_en from './locales/en/activity.json';

const resources = {
  ja: {
    translation: common_ja,
    home: home_ja,
    customer: customer_ja,
    deleteCustomer: deleteCustomer_ja,
    billing: billing_ja,
    customerInfo: customerInfo_ja,
    deleteScheduled: deleteScheduled_ja,
    teamManagement: teamManagement_ja,
    activity: activity_ja
  },
  en: {
    translation: common_en,
    home: home_en,
    customer: customer_en,
    deleteCustomer: deleteCustomer_en,
    billing: billing_en,
    customerInfo: customerInfo_en,
    deleteScheduled: deleteScheduled_en,
    teamManagement: teamManagement_en,
    activity: activity_en
  }
};

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    ns: ['translation', 'home', 'customer', 'deleteCustomer', 'billing', 'customerInfo', 'deleteScheduled', 'teamManagement', 'activity'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      initImmediate: true,
      useSuspense: true,
    }
  });

export default i18next;
